class FixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.productForm = this.externalEls['product-form']?.element
    if (!this.productForm) {
      return
    }

    this.checkProductFormPosition()

    this.productFormVisible = false

    this.handleScroll = this.throttle(this.checkProductFormPosition.bind(this), 100)

    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener('scroll', this.handleScroll)
    document.addEventListener('variantChange', this.updateSelect.bind(this))

    if (!this.els?.select?.element) {
      console.error('Select element not found')
      return
    }

    this.els.select.element.addEventListener('change', this.clickProductForm.bind(this))
  }

  checkProductFormPosition () {
    const rect = this.productForm.getBoundingClientRect()
    const isOffTop = rect.top <= 0
    const isOnScreen = rect.top < window.innerHeight && rect.bottom > 0
    const mode = this.dataset.displayMode

    if (mode === 'below') {
      this.isHidden = !isOffTop
    } else {
      this.isHidden = isOnScreen
    }
  }

  updateSelect () {
    const productVariants = document.querySelectorAll('variant-radios [data-variant-radios-el="option-choice"]')

    if (!productVariants || productVariants.length === 0) {
      console.error('No product variants found')
      return
    }

    productVariants.forEach(variant => {
      if (variant.checked) {
        this.selectedVariant = variant
      }
    })

    if (!this.selectedVariant) {
      console.error('No selected variant found')
      return
    }

    this.els.select.element.value = this.selectedVariant.value

    const chosenVariantImage = this.selectedVariant.closest('div').querySelector('[data-variant-image]')
    if (chosenVariantImage) {
      this.els.image.element.innerHTML = chosenVariantImage.outerHTML
    } else {
      console.error('No image found for selected variant')
    }

    this.els.title.elements.forEach(title => {
      title.innerHTML = this.selectedVariant.value
    })
  }

  clickProductForm () {
    const variantRadio = document.querySelector(`[data-variant-radios-el="option-choice"][data-variant-title="${this.els.select.element.value}"]`)
    if (variantRadio) {
      variantRadio.click()
    } else {
      console.error('No variant found for the selected title:', this.els.select.element.value)
    }
  }

  throttle (fn, wait) {
    let lastTime = 0
    return function (...args) {
      const now = new Date().getTime()
      if (now - lastTime >= wait) {
        lastTime = now
        fn(...args)
      }
    }
  }

  get isHidden () {
    return this._isHidden
  }

  set isHidden (isHidden) {
    this._isHidden = isHidden
    this.setAttribute('aria-hidden', String(isHidden))
  }

  disconnectedCallback () {
    window.removeEventListener('scroll', this.handleScroll)
    super.disconnectedCallback()
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
